export default __webpack_public_path__ + "static/Pala_8-217c8652b7d7be4df9952d77718e178e.png";